<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >                                               
                  <b-nav style="width:100%" class="tabs-sw" tabs>
                    <b-nav-item :active="active===3" @click="active=3;changeContacto(3)"  class="d-none d-md-block">Individual</b-nav-item>
                    <b-nav-item :active="active===2" @click="active=2;changeContacto(2)"  class="d-none d-md-block">Asesor</b-nav-item>
                    <b-nav-item :active="active===0" @click="active=0;changeContacto(0)"  class="d-none d-md-block">Centro de trabajo</b-nav-item>
                    <b-nav-item :active="active===1" @click="active=1;changeContacto(1)"  class="d-none d-md-block">Razón Social</b-nav-item>
                  </b-nav>  
                  <div style="width:100%;border:1px solid; border-top:none;border-color: #dee2e6;border-radius: 0 0 3px 3px" class="p-3"> 
                    <b-row style="width:100%;margin-bottom:20px;margin-top:20px"  v-if="dataForm[namePath].info_ingresos.id_list_forma!==1">                      
                      <sw-inputs
                            v-show="active!==3"
                            inputTabla="info_ingresos"
                            inputCampo="id_datos_razon"
                            inline
                            :md="4" :lg="4">
                          </sw-inputs>                     
                          <sw-inputs
                            inputTabla="info_ingresos"
                            inputCampo="id_list_forma"
                            modalVariant="secondary"
                            modalTitle="Agregar forma de pago"
                            modalSize="sm"
                            inline
                            :md="5" :lg="5">
                            <template v-slot:modal="modalInput">
                              <sw-modallistforma 
                                @cerrar="modalInput.modalInput.value=false">
                              </sw-modallistforma>
                            </template>
                          </sw-inputs>                      
                        <sw-inputs
                            class="col-lg-2 col-md-2 col-sm-12"
                            style="margin-top: 5px;"
                            inputTabla="info_ingresos"
                            inputCampo="label_consecutivo"
                            :showLabel="false"
                            inline>
                          </sw-inputs>  
                          <b-form-checkbox
                            v-if="active===3"
                            @input="changeReporte"
                            v-model="reporte"
                            name="checkbox-1"
                            style="padding-top: 8px;padding-left: 35px;"
                            >
                            Solo reporte de asesor
                          </b-form-checkbox>
                          <sw-inputs
                            inputTabla="info_ingresos"
                            inputCampo="descripcion"
                            inline
                            :md="12" :lg="12">
                          </sw-inputs>
                    </b-row>  
                    <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_ingresos.id_list_forma===1">                      
                      <sw-inputs
                            v-show="active!==3"
                            inputTabla="info_ingresos"
                            inputCampo="id_datos_razon"
                            inline
                            :md="4" :lg="4">
                          </sw-inputs>                     
                          <sw-inputs
                            inputTabla="info_ingresos"
                            inputCampo="id_list_forma"
                            modalVariant="secondary"
                            modalTitle="Agregar forma de pago"
                            modalSize="sm"
                            inline
                            :md="5" :lg="5">
                            <template v-slot:modal="modalInput">
                              <sw-modallistforma 
                                @cerrar="modalInput.modalInput.value=false">
                              </sw-modallistforma>
                            </template>
                          </sw-inputs>    
                          <b-col :md="4" :lg="4">
                          </b-col>                                          
                          <sw-inputs
                            inputTabla="info_ingresos"
                            inputCampo="id_list_cuentas"
                            modalVariant="secondary"
                            modalTitle="Agregar cuenta"
                            modalSize="sm"
                            inline
                            :md="5" :lg="5">
                            <template v-slot:modal="modalInput">
                              <sw-modallistcuentas
                                @cerrar="modalInput.modalInput.value=false">
                              </sw-modallistcuentas>
                            </template> 
                          </sw-inputs>   
                          <b-col :md="4" :lg="4">
                          </b-col>                                               
                          <sw-inputs
                            style="margin-bottom:10px"
                            inputTabla="info_ingresos"
                            inputCampo="consignacion"
                            inline
                            :md="5" :lg="5">
                          </sw-inputs>                
                          <sw-inputs
                            inputTabla="info_ingresos"
                            inputCampo="descripcion"
                            inline
                            :md="12" :lg="12">
                          </sw-inputs>
                    </b-row>                   
                    <b-row v-show="active!==3" style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                      <b-col md="6">
                          <span style="font-weight: 500;display:inline-block;width:80px">Contacto:</span> {{regAfiliacion.name}}<br>
                          <span style="font-weight: 500;display:inline-block;width:80px">Dirección:</span> {{regAfiliacion.direccion}} <br>
                          <span style="font-weight: 500;display:inline-block;width:80px">Teléfonos:</span> {{regAfiliacion.telefonos}}<br>
                      </b-col>  
                      <b-col md="6">
                          <span style="font-weight: 500;display:inline-block;width:100px">Documento:</span> {{regAfiliacion.documento}} <br>     
                          <span style="font-weight: 500;display:inline-block;width:100px">Correo:</span> {{regAfiliacion.email}} <br>                      
                          <span style="font-weight: 500;display:inline-block;width:100px"> Asesor:</span>  {{asesorName}}<br>                        
                      </b-col> 
                    </b-row>  
                    <b-row v-show="active!==3" style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">
                      <b-col md="6" style="text-align:justify">
                          <span style="font-weight: 500;display:inline-block;width:80px; ">Concepto:</span> {{dataForm[namePath].info_ingresos.descripcion}} de {{dataPost[namePath].data.length}} afiliado(s).
                      </b-col>  
                      <b-col md="6">
                          <span style="font-weight: 500;display:inline-block;width:100px">Valor:</span> {{dataForm[namePath].info_ingresos.valor}} <br>
                          <b-form-checkbox
                            @input="changeReporte"
                            v-model="reporte"
                            name="checkbox-1"
                            >
                            Solo reporte de asesor
                          </b-form-checkbox>
                      </b-col> 
                    </b-row> 
                    <h6 style="margin-bottom:0;margin-top:40px">Afiliados agrupados</h6>
                    <table  style="margin-bottom:0;margin-top:10px" class="table table--get table-hover border box-effect linear">
                      <thead>
                        <tr>
                          <th>Documento</th>
                          <th>Nombres</th>
                          <th>Servicios</th>
                          <th>Razón</th>
                          <th>Asesor</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(items,index) in espejoDataPost" :key="'listadoAfilaicion'+index">
                          <td>{{gettersDatalist('list_documento',items.datos_afiliado.id_list_documento)[0].name}} {{items.datos_afiliado.documento}}</td>
                          <td>{{items.datos_afiliado.name}}</td>
                          <td>{{nameServicios(items.servicios_nuevos,gettersDatalist('datos_razon',items.info_afiliacion.id_datos_razon)[0].id_list_arl)}}</td>
                          <td>{{gettersDatalist('datos_razon',items.info_afiliacion.id_datos_razon)[0].name}}</td>
                          <td>{{gettersDatalist('datos_asesor',items.info_afiliacion.id_datos_asesor)[0].name}}</td>
                          <td>{{preciosServicios(items.servicios_nuevos)+preciosServicios(items.servicios_activos)}}</td>                          
                        </tr>
                      </tbody>
                    </table>   
                  </div>              
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px -15px; padding: 0;    padding-bottom: 15px;">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="Afiliación"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import Multiselect  from '@/components/vue-multiselect/src/'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,  
    'c-multiselect': Multiselect,
    SwModallistcuentas, 
    SwModallistforma
  },
  props: {
  },
  data()
  {
    return {
      valor: 0,
      reporte: false,
      valorReporte: 0,
      createdCycle: true,
      active: 3,
      alguno: 0,
      alguno2: 0,
      regAfiliacion: {
        name: null,
        documento: null,
        direccion:null,
        telefonos:null,
        email:null
      },
      asesorName: null,
      espejoDataPost: []
    }
  },
  async updated()
  {
    await this.resetDataForm({state: 'info_ingresos/descripcion'})
  },
  async created(){
    try{      
      let await0 = this.updateGlobal({state: 'openModal/modal/value', data: false})
      let await1 = this.updateDataIndex({data: 10000})     

      let awaitAll = await Promise.all([await0,await1])
      let throwAll = awaitAll.findIndex(list => list === false)
      if(throwAll!==-1)
      {
        throw ('in line 163 at 165')
      }
       
      let asesorData = this.gettersDatalist('datos_asesor',this.dataPost[this.namePath].data[0].info_afiliacion.id_datos_asesor)[0]   

      this.regAfiliacion=asesorData
      this.asesorName = this.regAfiliacion.name  
      let j=0
      for (let i = 0; i < this.dataPost[this.namePath].data.length; i++) {
        this.valor=this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_nuevos)+this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_activos)+this.valor
        this.valorReporte=this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)+this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_activos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)+this.valorReporte

        this.dataPost[this.namePath].data[i].afiliacion_registro.valor=this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_nuevos)+this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_activos)
        this.dataPost[this.namePath].data[i].afiliacion_registro.reporte=this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)+this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_activos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)
        this.dataPost[this.namePath].data[i].afiliacion_registro.comision=this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_nuevos)+this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_activos)-this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)-this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_activos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)
        this.dataPost[this.namePath].data[i].afiliacion_registro.comision = this.dataPost[this.namePath].data[i].afiliacion_registro.comision <0 ? 0 : this.dataPost[this.namePath].data[i].afiliacion_registro.comision

      }       
         
      let await10 = this.updateDataForm({state: 'info_ingresos/valor', data: this.valor}) 
      let await11 
      if(this.dataPost[this.namePath].data[0].info_afiliacion.id_datos_asesor==1)
      {
        this.valorReporte=this.valor
        await11 =this.updateDataForm({state: 'info_ingresos/reporte', data: this.valor})
      }
      else
      {
        await11 = this.updateDataForm({state: 'info_ingresos/reporte', data: this.valorReporte})
      }
      let await13 = this.updateDataForm({state: 'info_ingresos/tipo', data: 0 })
      let await14 = this.updateDataForm({state: 'info_ingresos/id_datos_asesor', data: this.dataPost[this.namePath].data[0].info_afiliacion.id_datos_asesor})
      let await15 = this.updateDataForm({state: 'info_ingresos/name', data:  this.regAfiliacion.name})
      let await16 = this.updateDataForm({state: 'info_ingresos/documento', data:  this.regAfiliacion.documento})
      let await17 = this.updateDataForm({state: 'info_ingresos/direccion', data:  this.regAfiliacion.direccion})
      let await18 = this.updateDataForm({state: 'info_ingresos/telefonos', data:  this.regAfiliacion.telefonos})
      let await19 = this.updateDataForm({state: 'info_ingresos/email', data:  this.regAfiliacion.email})
      let await20 = this.updateDataForm({state:'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
      let await21 = this.updateDataForm({state: 'info_ingresos/id_datos_razon', data: this.dataPost[this.namePath].data[0].info_afiliacion.id_datos_razon})

      awaitAll = await Promise.all([await10,await11,await13,await14, await15, await16, await17, await18, await19, await20, await21])
      throwAll = awaitAll.findIndex(list => list === false)

      if(throwAll!==-1)
      {
        throw ('in line 189 at 208')
      }

      await this.updateGlobal({state:'openModal/modal/loaded',data:true})
      this.espejoDataPost=this.deepCopy(this.dataPost[this.namePath].data)
    }
    catch (e) {
      console.log('create in modal afiliacion grupal',e)
      this.cerrarEsto()
    }  
  },
  destroyed()
  {
    this.resetDataIndex()
    this.updateDataPost({state: 'data',data: this.espejoDataPost})
  },
  computed: { 
  },
  methods: {
    reporteServicios(value,asesor)
    { 
      try {
        let asesorData = this.gettersDatalist('datos_asesor',asesor)[0] 
        let valor=0
        for(let i=0;i<value.length;i++)
        { 
          if(asesor===1)
          {
              valor=value[i].afiliacion
          }
          else 
          {
            if(value[i].name==='Riesgo')
            {
              valor= valor+parseInt(asesorData['r'+value[i].id_list])
            }
            if(value[i].name==='Ccf')
            {
              valor= valor+parseInt(asesorData['ccf'])
            }
            if(value[i].name==='Afp')
            {
              valor= valor+parseInt(asesorData['afp'])
            } 
          }   
        } 
        return valor
      } catch (e) {
        console.log('precios servicios in modals/afiliacionGrupal',e)
      }
    },
    preciosServicios(value)
    { 
      try {
        let valor=0
        for(let i=0;i<value.length;i++)
        { 
          valor=valor+value[i].afiliacion
        } 
        return valor
      } catch (e) {
        console.log('precios servicios in modals/afiliacionGrupal',e)
      }
    },
    nameServicios(value,arl){ 
      try {
        let name=''
        for(let i=0;i<value.length;i++)
        { 
          if(value[i].name!='Administración')
          {
            if(value[i].name==='Riesgo')
            {
              name=name+' ARL '+this.gettersDatalist('list_arl',arl)[0].name+' '
            }
            name=name+' '+value[i].name
            if(value[i].name_list!==null && value[i].name_list!=='')
            {
              
              name=name+' '+this.gettersDatalist(value[i].name_list,value[i].id_list)[0].name+' '
            }
          }
        } 
        return name
      } catch (e) {
        console.log('name servicios in modals/afiliacionGrupal',e)
      }
    },
    async cerrarEsto()
    {
      await this.resetGlobal({state: 'openModal', data: false})
    },
    async changeContacto(event)
    {  
      try {
        let await14
        switch(event)  
        {
          case 0 : 
            this.regAfiliacion = this.gettersDatalist('datos_contacto',this.espejoDataPost[0].info_afiliacion.id_datos_contacto)[0]
            await14 = this.updateDataForm({state: 'info_ingresos/tipo', data:  1})
            this.updateDataForm({state: 'info_ingresos/id_list_documento', data: 1})
          break  
          case 1 : 
            this.regAfiliacion = this.gettersDatalist('datos_razon',this.espejoDataPost[0].info_afiliacion.id_datos_razon)[0]
            await14 = this.updateDataForm({state: 'info_ingresos/tipo', data:  1})
            this.updateDataForm({state: 'info_ingresos/id_list_documento', data: regAfiliacion.id_list_documento})
          break  
          case 2 : 
            this.regAfiliacion = this.gettersDatalist('datos_asesor',this.espejoDataPost[0].info_afiliacion.id_datos_asesor)[0]
            this.regAfiliacion.direccion= null
            await14 = this.updateDataForm({state: 'info_ingresos/tipo', data:  1})
            this.updateDataForm({state: 'info_ingresos/id_list_documento', data: 1})
          break  
          case 3 : 
            this.regAfiliacion = {
              name: null,
              documento: null,
              direccion:null,
              telefonos:null,
              email:null
            }
            await14 = this.updateDataForm({state: 'info_ingresos/tipo', data:  0})
          break 
        }
        const await15 = this.updateDataForm({state: 'info_ingresos/name', data:  this.regAfiliacion.name})
        const await16 = this.updateDataForm({state: 'info_ingresos/documento', data:  this.regAfiliacion.documento})
        const await17 = this.updateDataForm({state: 'info_ingresos/direccion', data:  this.regAfiliacion.direccion})
        const await18 = this.updateDataForm({state: 'info_ingresos/telefonos', data:  this.regAfiliacion.telefonos})
        const await19 = this.updateDataForm({state: 'info_ingresos/email', data:  this.regAfiliacion.email})

        const awaitAll = await Promise.all([await14, await15, await16, await17, await18, await19])
        const throwAll = awaitAll.findIndex(list => list === false)

        if(throwAll!==-1)
        {
          throw ('in line 260 at 267')
        }
        return true
      }
      catch(e){
        console.log('change contacto in modals/afiliacionGrupal',e)
      }
     
    },
    async changeReporte()
    {
      try {
        if(this.reporte===true)
        {
          await this.updateDataForm({state: 'info_ingresos/valor', data: this.valorReporte})
          return true
        }
        await this.updateDataForm({state: 'info_ingresos/valor', data: this.valor})
        return true
      } catch(e) {
        console.log('change reporte in modals/afiliacionGrupal')
      }
    },
    async save(event)
    {
      try
      {
        await this.updateDataPost({state: 'data',data: this.espejoDataPost})
        let await0=true
        if(this.dataForm[this.namePath].info_ingresos.id_list_forma===2 || this.dataForm[this.namePath].info_ingresos.id_list_forma===5)
        {
          await0 = this.updateDataForm({state: 'info_ingresos/fecha', data: null})
        }
        let await1 = this.updateDataForm({state: 'info_ingresos/descripcion', data: this.dataForm[this.namePath].info_ingresos.descripcion+' de '+this.deepCopy(this.dataPost[this.namePath].data).length+' afiliados'})
        
        const awaitAll = await Promise.all([await0, await1])
        const throwAll = awaitAll.findIndex(list => list === false)
        if(throwAll!==-1)
        {
          throw ('in line 356 at 364')
        }

        if(this.dataForm[this.namePath].info_ingresos.tipo===1)
        {
          for(let i = 0; i < this.dataPost[this.namePath].data.length; i++)
          {            
            if(this.reporte===true)
            {
              this.dataPost[this.namePath].data[i].afiliacion_registro.reporte=this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)+this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_activos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)
              this.dataPost[this.namePath].data[i].afiliacion_registro.valor=this.dataPost[this.namePath].data[i].afiliacion_registro.reporte
              this.dataPost[this.namePath].data[i].afiliacion_registro.comision=0
            }            
          }
          this.dataPost[this.namePath].data.splice(0,0,{info_ingresos: this.dataForm[this.namePath].info_ingresos})

        }
        if(this.dataForm[this.namePath].info_ingresos.tipo===0)
        {
          await this.resetDataForm({state: 'info_ingresos/descripcion'})
          let newDataPost= []
          for (let i = 0; i < this.dataPost[this.namePath].data.length; i++) {
            let valorIngreso=this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_nuevos)+this.preciosServicios(this.dataPost[this.namePath].data[i].servicios_activos)
            let asesorData = this.gettersDatalist('datos_asesor',this.dataPost[this.namePath].data[0].info_afiliacion.id_datos_asesor)[0]   
            let razonData = this.gettersDatalist('datos_razon',this.dataPost[this.namePath].data[0].info_afiliacion.id_datos_razon)[0]  
            this.regAfiliacion=asesorData
            if(this.reporte===true)
            {
              this.dataPost[this.namePath].data[i].afiliacion_registro.reporte=this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)+this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_activos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)
              this.dataPost[this.namePath].data[i].afiliacion_registro.valor=this.dataPost[this.namePath].data[i].afiliacion_registro.reporte
              this.dataPost[this.namePath].data[i].afiliacion_registro.comision=0
              valorIngreso=this.dataPost[this.namePath].data[i].afiliacion_registro.reporte
            }


            let info_ingresos={
              id:null,
              id_list_forma: this.dataForm[this.namePath].info_ingresos.id_list_forma,
              id_list_cuentas: this.dataForm[this.namePath].info_ingresos.id_list_cuentas,
              id_list_documento: this.dataPost[this.namePath].data[i].datos_afiliado.id_list_documento,
              id_datos_razon : this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_razon,
              id_datos_asesor : this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor,
              name : this.dataPost[this.namePath].data[i].datos_afiliado.name,
              documento : this.dataPost[this.namePath].data[i].datos_afiliado.documento,
              consecutivo : this.dataForm[this.namePath].info_ingresos.consecutivo,
              fecha : this.dataForm[this.namePath].info_ingresos.fecha,
              consignacion : this.dataForm[this.namePath].info_ingresos.consignacion,
              direccion : this.dataPost[this.namePath].data[i].datos_afiliado.direccion,
              telefonos : this.dataPost[this.namePath].data[i].datos_afiliado.telefonos,
              email : this.dataPost[this.namePath].data[i].datos_afiliado.email,
              valor : valorIngreso,
              reporte : this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor)+this.reporteServicios(this.dataPost[this.namePath].data[i].servicios_activos,this.dataPost[this.namePath].data[i].info_afiliacion.id_datos_asesor),
              label_consecutivo : this.dataForm[this.namePath].info_ingresos.label_consecutivo,
              tipo: 0,
              descripcion:this.dataForm[this.namePath].info_ingresos.descripcion+this.nameServicios(this.dataPost[this.namePath].data[i].servicios_nuevos,razonData.id_list_arl),
              observacion:this.dataForm[this.namePath].info_ingresos.observacion,
            };  
            newDataPost.push({
              info_ingresos: info_ingresos,
              datos_afiliado: this.dataPost[this.namePath].data[i].datos_afiliado,
              info_afiliacion: this.dataPost[this.namePath].data[i].info_afiliacion,
              afiliacion_registro: this.dataPost[this.namePath].data[i].afiliacion_registro,
              servicios_nuevos: this.dataPost[this.namePath].data[i].servicios_nuevos,
              servicios_activos: this.dataPost[this.namePath].data[i].servicios_activos,
              afiliado_beneficiarios: this.dataPost[this.namePath].data[i].afiliado_beneficiarios,
            }
            )        
          }
          await this.updateDataPost({state: 'data',data: newDataPost})
        }
        this.$emit('save',{save:event.save, savePost: true, ftn: 'afiliacionGrupalFtn' })
      }catch(e){
        console.log('save in modals/afiliacionGrupal', e)
      }
    },    
  }
}
</script>
<style>
.tabs-sw{
    padding-left: 10px;
    width: 100%;
    padding-top: 12px;
    border-radius: 3px 3px 0 0;
    border: 1px solid #dee2e6;
    background-color: rgba(0,0,0,.03);
}
.tabs-sw .nav-link.active{
  background:white;
} 
.modal-footer{
  background:#fbfbfb;
  margin: 0px -15px -15px;
  padding: 0px;
  padding-bottom: 11px;
}
</style>